import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Stack, TextField } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import moment from 'moment';
import { __jobStatus, __jobStatusDisplay, __permissionsObj } from '../../constants';

const Filter = ({ filterState, setFilterState, callFunction }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [value, setValue] = React.useState([null, null]);

  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = (event) => {
    setFilterState({ ...filterState, status: event.target.value });
  };

  const handleRoleChange = (event) => {
    setFilterState({ ...filterState, fRole: event.target.value });
  };

  const handleDurationTypeChange = (event) => {
    setFilterState({ ...filterState, durationType: event.target.value });
  };

  const handleStripeDisabledChange = (event) => {
    setFilterState({ ...filterState, stripeDisabled: event.target.value });
  };

  const handleApply = () => {
    callFunction();
    setAnchorEl(null);
  };

  const handleClear = () => {
    setFilterState({});
    setValue([null, null]);
    callFunction(1, false);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        size='small'
        sx={{ p: 0, minWidth: "50px" }}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <Tooltip title="Filter">
          <FilterAltIcon />
        </Tooltip>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <div style={{ padding: "1rem", maxWidth: '350px' }}>
          <FormControl>
            <strong>By Status</strong>
            <RadioGroup
              row={true}
              aria-labelledby="status-row-radio-buttons-group-label"
              name="status-radio-buttons-group"
              value={filterState?.status ?? ""}
              onChange={handleStatusChange}
            >
              {Object.entries(__jobStatus).map(([statusKey, statusCode]) => (
                <FormControlLabel
                  key={statusCode}
                  value={statusCode}
                  control={<Radio />}
                  label={__jobStatusDisplay[statusCode] || statusKey}
                />
              ))}
            </RadioGroup>
          </FormControl>

          <br />
          <br />

          <FormControl>
            <strong>By Role</strong>
            <RadioGroup
              row={true}
              aria-labelledby="role-row-radio-buttons-group-label"
              name="role-radio-buttons-group"
              value={filterState?.fRole ?? ""}
              onChange={handleRoleChange}
            >
              <FormControlLabel value={__permissionsObj.HouseKeeper} control={<Radio />} label={__permissionsObj.HouseKeeper} />
              <FormControlLabel value={__permissionsObj.BabySitter} control={<Radio />} label={__permissionsObj.BabySitter} />
            </RadioGroup>
          </FormControl>

          <br />
          <br />

          <FormControl>
            <strong>By Duration Type</strong>
            <RadioGroup
              row={true}
              aria-labelledby="duration-type-row-radio-buttons-group-label"
              name="duration-type-radio-buttons-group"
              value={filterState?.durationType ?? ""}
              onChange={handleDurationTypeChange}
            >
              <FormControlLabel value="Immediate" control={<Radio />} label="Immediate" />
              <FormControlLabel value="Long Term" control={<Radio />} label="Long Term" />
              <FormControlLabel value="Future" control={<Radio />} label="Future" />
            </RadioGroup>
          </FormControl>

          <br />
          <br />

          <FormControl>
            <strong>By Stripe Disabled</strong>
            <RadioGroup
              row={true}
              aria-labelledby="stripe-disabled-row-radio-buttons-group-label"
              name="stripe-disabled-radio-buttons-group"
              value={filterState?.stripeDisabled ?? ""}
              onChange={handleStripeDisabledChange}
            >
              <FormControlLabel value="true" control={<Radio />} label="Disabled" />
              <FormControlLabel value="false" control={<Radio />} label="Enabled" />
            </RadioGroup>
          </FormControl>

          <br />

          <div className='date_div' style={{ marginTop: "1rem" }}>
            <div><strong>By Date</strong></div>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} style={{ marginTop: "1rem", marginBottom: '2rem' }}>
              <TextField
                id='Date From'
                type={"date"}
                fullWidth
                defaultValue={filterState.startDate ? moment(filterState.startDate).format('YYYY-MM-DD') : ""}
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    startDate: moment(e.target.value).format('YYYY-MM-DD')
                  });
                }}
              />

              <TextField
                id='Date To'
                type={"date"}
                fullWidth
                defaultValue={filterState.endDate ? moment(filterState.endDate).format('YYYY-MM-DD') : ""}
                onChange={(e) => {
                  setFilterState({
                    ...filterState,
                    endDate: moment(e.target.value).format('YYYY-MM-DD')
                  });
                }}
              />
            </Stack>
          </div>

          <Actions>
            <Button variant="contained" size='small' style={{ textTransform: "unset" }} onClick={handleApply}>Apply filter</Button>
            <Button variant="outlined" size='small' style={{ textTransform: "unset" }} onClick={handleClear}>Clear filter</Button>
          </Actions>
        </div>
      </Menu>
    </>
  );
};

const Actions = styled("div")`
  margin-top: 1rem;
  display: flex;
  column-gap: 1rem;
`;

export default Filter;